
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('coa')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/accounting/account" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('add_new')}}</router-link>
            <router-link to="/accounting/import/account" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-file-excel-o"></i> {{$t('import')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" v-model="query.Text" @keypress.enter="toList" placeholder="ស្វែងរកតាមលេខកូដ ឈ្មោះ" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <select class="form-control form-control-sm" v-model="query.AccountTypeId" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option v-for="ret in accountTypes" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>            
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('barcode')}}</th>
                            <th>{{ $t('name')}}</th>
                            <th>{{ $t('account_type') }}</th>
                            <th>{{ $t('description') }}</th>
                            <th class="text-center">{{ $t('sort')}}</th>
                            <th style="width: 22px;"></th>
                        </tr>
                        </thead>
                        <tbody>
                            <template v-if="viewType==0">
                                <tr v-for="(ret, index) in records" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td><router-link :to="{name:'chart_of_account_update',params:{id:ret.Id}}">{{ret.Num}}</router-link></td>
                                    <td>{{ret.Name}}</td>
                                    <td>{{ret.AccountTypeName}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td class="text-center">{{ret.Sort}}</td>
                                    <td>
                                        <button type="button" class="btn btn-danger btn-table-xs btn-delete" @click="onDelete(ret.Id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <template v-for="(record,lindex) in recordGroups">
                                    <tr :key="lindex+'col'">
                                        <th colspan="7">{{record.AccountType}}</th>
                                    </tr>
                                    <tr v-for="(ret, index) in record.Accounts" :key="lindex+'-'+index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td><router-link :to="{name:'chart_of_account_update',params:{id:ret.Id}}">{{ret.Num}}</router-link></td>
                                        <td>{{ret.Name}}</td>
                                        <td>{{ret.AccountTypeName}}</td>
                                        <td>{{ret.Description}}</td>
                                        <td class="text-center">{{ret.Sort}}</td>
                                        <td>
                                            <button type="button" class="btn btn-danger btn-table-xs btn-delete" @click="onDelete(ret.Id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Swal from 'sweetalert2';
    export default {
        data: function() {
            return {
                records: [],
                recordGroups: [],
                accountTypes: [],
                viewType: 0
            };
        },
        created: function() {
            const filter = this.$store.state.filter.coa;
            if(filter == undefined || filter == null){
                this.$store.state.filter.coa = {
                    Text: '',
                    AccountTypeId: '',
                    IsGroup: false,
                    Page: 1,
                    Limit: 25,
                    Total: 0
                };
            }else{
                this.viewType = this.query.IsGroup?1:0;
            }
            this.toList();
            this.typeList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('accounting/accounts', this.query).then(res => {
                    if (this.$isValid(res)) {
                        if(this.viewType == 0){
                            this.records = res.data.Data;
                        }else{
                            this.recordGroups = res.data.Json.AccountGroups;
                        }
                        this.query.Total = res.data.Total;
                    }
                }).finally(function(){ loading.hide(); });
            },
            typeList(){
                var loading = this.$loading.show();
                this.$api().post('accounting/types', {}).then(res => {
                    if (this.$isValid(res)) {
                        this.accountTypes = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            viewTypeChange(n){
                this.viewType = n;
                this.$store.state.filter.coa.IsGroup = n==0?false:true;
                this.toList();
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            onDelete(id){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                    if (result.value) {
                        this.$api().post('accounting/delete/account', { Id: id }).then(res => {
                            if(this.$isValid(res)){
                                this.toList();
                                Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
                            }
                        });
                    }
                });
            }
        },
        computed: {
            query(){
                return this.$store.state.filter.coa;
            }
        }
    };
</script>
<style scoped>
    .btn-delete {
        height: 20px;
        width: 22px;
        line-height: 0;
    }
</style>
